import React, { useState, useRef, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { FormControl, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { ValidatorForm } from "react-material-ui-form-validator";
import { productCategoriesActions } from "../../../../store/product/productCategoriesAction";
import { InputField } from "../../../../components/common";
import { ProductsOwnedQtyList, ProductStatus } from "../../../../config/Enums";
import OutsideClickHandler from "react-outside-click-handler";

const handleSubmit = e => {
  e.preventDefault();
};

const colors = [
  { color: "#015dfe" },
  { color: "#00d0ff" },
  { color: "#f9b900" },
  { color: "#ff0092" },
  { color: "#49b8ef" },
  { color: "#eb5757" },
  { color: "#66de64" },
  { color: "#0a42e9" },
  { color: "#ef64b3" },
  { color: "#e8edef" },
];

const CategoryFiltersSection = ({
  SelectedPC,
  setSelectedPC,
  SubCategories,
  SelectedSCs,
  setSelectedSC,
  BusinessGroups,
  BusinessGroupIds,
  setBGIds,
  ContactTypes,
  ContactTypeIds,
  setCntTypeIds,
  Environments,
  EnvironmentIds,
  setEnvIds,
  noOfContacts,
  setNoOfContacts,
  companyName,
  setCompanyName,
  groupName,
  setGroupName,
  DeviceRegisteredQty,
  setDeviceRegisteredQty,
  productStatus,
  setProductStatus,
  color,
  setGroupColor,
  hideFilters,
}) => {
  const dispatch = useDispatch();

  const [parentCategories, setParentCategories] = useState([]);
  const [colorOption, setColorOption] = useState(false);
  const [inputAllowed, setInputAllowed] = useState(false);
  const loadProductCategories = useCallback(
    ({ parentCatId = 0 }) => {
      dispatch(
        productCategoriesActions.onGetAllProductSubCategories(parentCatId)
      ).then(data => {
        if (data?.success) {
          if (parentCatId === 0) {
            setParentCategories(data?.data);
          }
        }
      });
    },
    [dispatch]
  );

  useEffect(() => {
    loadProductCategories({ parentCatId: 0 });
  }, [loadProductCategories]);

  function handleKeyPress(event) {
    if (!inputAllowed) {
      event.preventDefault();
    }
  }
  console.log({ color, colorOption });
  return (
    <ValidatorForm ref={useRef("form")} onSubmit={handleSubmit}>
      <div className='userDetailsSearchField inputWrapper filterSelect'>
        <FormControl className='ac-dd'>
          <Autocomplete
            value={BusinessGroups.filter(eg =>
              BusinessGroupIds.includes(eg.id)
            )}
            onChange={(event, value) => setBGIds(value?.map(g => g.id))}
            multiple
            filterSelectedOptions
            id='business-group'
            options={BusinessGroups}
            getOptionLabel={option => option?.value || ""}
            renderInput={params => (
              <TextField
                {...params}
                inputProps={{ ...params.inputProps, autoComplete: "none" }}
                placeholder={"Business Group"}
              />
            )}
          />
          {BusinessGroupIds?.length > 0 && (
            <span className='countLabel'>{BusinessGroupIds?.length}</span>
          )}
        </FormControl>

        <FormControl className='ac-dd'>
          <Autocomplete
            value={ContactTypes?.filter(eg => ContactTypeIds?.includes(eg.id))}
            onChange={(event, value) => setCntTypeIds(value?.map(g => g.id))}
            multiple
            filterSelectedOptions
            id='contact-type'
            options={ContactTypes ?? []}
            getOptionLabel={option => option?.value || ""}
            renderInput={params => (
              <TextField
                {...params}
                inputProps={{ ...params.inputProps, autoComplete: "none" }}
                placeholder={"Contact Type"}
              />
            )}
          />
          {ContactTypeIds?.length > 0 && (
            <span className='countLabel'>{ContactTypeIds?.length}</span>
          )}
        </FormControl>

        <FormControl className='ac-dd'>
          <Autocomplete
            value={SelectedPC}
            onChange={(event, value) => {
              setSelectedPC(value);
            }}
            multiple
            filterSelectedOptions
            id='product-category-dd'
            options={parentCategories}
            getOptionLabel={option => option?.value || ""}
            renderInput={params => (
              <TextField
                {...params}
                inputProps={{ ...params.inputProps, autoComplete: "none" }}
                placeholder={"Product Category"}
              />
            )}
          />
          {SelectedPC?.length > 0 && (
            <span className='countLabel'>{SelectedPC?.length}</span>
          )}
        </FormControl>

        <FormControl className='ac-dd'>
          <Autocomplete
            value={SelectedSCs}
            onChange={(event, value) => setSelectedSC(value)}
            multiple
            id='prod-sc-ac'
            options={SubCategories}
            getOptionLabel={option => option?.value || ""}
            renderInput={params => (
              <TextField
                {...params}
                inputProps={{ ...params.inputProps, autoComplete: "none" }}
                placeholder={"Product Sub Category"}
              />
            )}
          />
          {SelectedSCs?.length > 0 && (
            <span className='countLabel'>{SelectedSCs?.length}</span>
          )}
        </FormControl>

        <FormControl className='ac-dd'>
          <Autocomplete
            value={Environments.filter(eg => EnvironmentIds.includes(eg.id))}
            onChange={(event, value) => setEnvIds(value?.map(g => g.id))}
            multiple
            filterSelectedOptions
            id='environment'
            options={Environments}
            getOptionLabel={option => option?.value || ""}
            renderInput={params => (
              <TextField
                {...params}
                inputProps={{ ...params.inputProps, autoComplete: "none" }}
                placeholder={"Environment"}
              />
            )}
          />
          {EnvironmentIds?.length > 0 && (
            <span className='countLabel'>{EnvironmentIds?.length}</span>
          )}
        </FormControl>
        {hideFilters === "favGroupFilter" && (
          <FormControl className='ac-dd colorfilterContainer'>
            <InputField
              placeholder='Group Color'
              id='group-color'
              name='group-color'
              onChange={({ target }) => setGroupColor(target.value)}
              readOnly={false}
              onKeyPress={handleKeyPress}
              autoComplete={"off"}
              onClick={() => {
                setColorOption(true);
              }}
              value={color}
            />
            <OutsideClickHandler onOutsideClick={() => setColorOption(false)}>
              <span
                className='colorBox'
                style={{ background: `${color}` }}
                onClick={() => setColorOption(true)}
              />
              {colorOption && (
                <div className='colorOptions'>
                  {colors.map((item, index) => {
                    return (
                      <span ket={item.id}>
                        <button
                          style={{ background: `${item.color}` }}
                          onClick={() => {
                            setGroupColor(item.color);
                            setColorOption(false);
                          }}
                        />
                      </span>
                    );
                  })}
                </div>
              )}
            </OutsideClickHandler>
          </FormControl>
        )}
        {hideFilters === "favFilter" ||
        hideFilters === "favGroupFilter" ? null : (
          <FormControl className='ac-dd'>
            <Autocomplete
              value={DeviceRegisteredQty}
              onChange={(event, value) => {
                setDeviceRegisteredQty(value);
              }}
              multiple
              filterSelectedOptions
              id='product-owned-dd'
              options={ProductsOwnedQtyList}
              getOptionLabel={option => option?.value || ""}
              renderInput={params => (
                <TextField
                  {...params}
                  inputProps={{ ...params.inputProps, autoComplete: "none" }}
                  placeholder={"Products Owned Qty"}
                />
              )}
            />
            {DeviceRegisteredQty?.length > 0 && (
              <span className='countLabel'>{DeviceRegisteredQty?.length}</span>
            )}
          </FormControl>
        )}
      </div>
      {hideFilters === "favFilter" && (
        <div className='userDetailsSearchField inputWrapper filterSelect'>
          {/* <FormControl className='ac-dd'>
           <Autocomplete
             value={BusinessGroups.filter(eg =>
               BusinessGroupIds.includes(eg.id)
             )}
             onChange={(event, value) => setBGIds(value?.map(g => g.id))}
             multiple
             filterSelectedOptions
             id='business-group'
             options={BusinessGroups}
             getOptionLabel={option => option?.value || ""}
             renderInput={params => (
               <TextField
                 {...params}
                 inputProps={{ ...params.inputProps, autoComplete: 'none' }}
                 placeholder={"Product SKU"} />
             )}
           />
           {BusinessGroupIds?.length > 0 && (
             <span className='countLabel'>{BusinessGroupIds?.length}</span>
           )}
         </FormControl> */}

          {/* <FormControl className='ac-dd'>
            <Autocomplete
              value={ProductStatus.filter(eg => productStatus.includes(eg.value))}
              onChange={(event, value) => setProductStatus(value?.map(s => s.value))}
              multiple
              filterSelectedOptions
              id='user-active-inactive'
              options={ProductStatus}
              getOptionLabel={option => option?.name || ""}
              renderInput={params => (
                <TextField
                  {...params}
                  inputProps={{ ...params.inputProps, autoComplete: 'none' }}
                  placeholder={"Product Status"} />
              )}
            />
            {productStatus?.length > 0 && (
              <span className='countLabel'>{productStatus?.length}</span>
            )}
          </FormControl> */}

          {/* <FormControl className='ac-dd'>
           <InputField
             placeholder='No. of Contacts'
             id='Contacts'
             name='Contacts'
             onChange={({ target }) => {
               if (!isNaN(target.value)) {
                 setNoOfContacts(target.value);
               }
             }}
             autoComplete={"off"}
             value={noOfContacts}
           />
         </FormControl> */}
          {/* <FormControl className='ac-dd'>
           <InputField
             placeholder='Company Name'
             id='CompanyName'
             name='CompanyName'
             onChange={({ target }) => {
                 setCompanyName(target.value);
             }}
             autoComplete={"off"}
             value={companyName}
           />
         </FormControl> */}
          {/* <FormControl className='ac-dd'>
           <InputField
             placeholder='Group Name'
             id='GroupName'
             name='GroupName'
             onChange={({ target }) => {
                 setGroupName(target.value);
             }}
             autoComplete={"off"}
             value={groupName}
           />
         </FormControl> */}
        </div>
      )}
    </ValidatorForm>
  );
};

export { CategoryFiltersSection };
